import React from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";

const fbAppId = 287327482576162;

export const fragments = graphql`
  fragment HomePageSEO on PrismicHomepageData {
    seo_title {
      text
    }
    seo_image {
      alt
      gatsbyImageData(layout: CONSTRAINED)
    }
    seo_description {
      text
    }
    seo_keywords {
      text
    }
  }
  fragment FocusAreaSEO on PrismicFocusAreaData {
    seo_title {
      text
    }
    seo_image {
      alt
      gatsbyImageData(layout: CONSTRAINED)
    }
    seo_description {
      text
    }
    seo_keywords {
      text
    }
  }
  fragment PageSEO on PrismicPageData {
    seo_title {
      text
    }
    seo_image {
      alt
      gatsbyImageData(layout: CONSTRAINED)
    }
    seo_description {
      text
    }
    seo_keywords {
      text
    }
  }
  fragment ProjectSEO on PrismicProjectData {
    seo_title {
      text
    }
    seo_image {
      alt
      gatsbyImageData(layout: CONSTRAINED)
    }
    seo_description {
      text
    }
    seo_keywords {
      text
    }
  }
  fragment TeamMemberSEO on PrismicTeamMemberData {
    seo_title {
      text
    }
    seo_image {
      alt
      gatsbyImageData(layout: CONSTRAINED)
    }
    seo_description {
      text
    }
    seo_keywords {
      text
    }
  }
  fragment PostSeo on PrismicMediumPostData {
    seo_title {
      text
    }
    seo_image {
      alt
      gatsbyImageData(layout: CONSTRAINED)
    }
    seo_description {
      text
    }
    seo_keywords {
      text
    }
  }
`;

const query = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
        buildEnv
        buildTime
      }
    }
  }
`;

function SEO({ data, lang = 'en', meta = [], path }) {
  const { site } = useStaticQuery(query);
  const title = `${data?.data?.seo_title?.text || data?.data?.title?.text} | ${
    site.siteMetadata.title
  }`;
  const description =
    data?.data?.seo_description?.text || site.siteMetadata.description;
  const keywords = data?.data?.seo_keywords?.text;
  const image = data?.data?.seo_image?.gatsbyImageData?.images?.fallback?.src;
  const { buildEnv, buildTime, siteUrl } = site.siteMetadata;
  const url = `${siteUrl}${path ? `/${path}` : ""}${
    data?.uid ? `/${data?.uid}` : ""
  }`;

  const generateRobotsContent = (robotsData) => {
    const { noIndex, noFollow } = robotsData?.data?.robots || {};
    return [noIndex ? "noindex" : null, noFollow ? "nofollow" : null] // cSpell:disable-line
      .filter(Boolean)
      .join(",");
  };

  const robotsContent = generateRobotsContent(data);
  return (
    <>
      <html lang={lang} />
      <title>{title}</title>
      {robotsContent !== "" && <meta name="robots" content={robotsContent} />}
      {/* <link rel="canonical" href={canonical} /> */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="fb:app_id" content={fbAppId} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="environment" content={buildEnv} />
      <meta name="build-time" content={buildTime} />
    </>
  );
}

SEO.propTypes = {
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
};

export default SEO;
